import { ref, onUnmounted, onMounted, onBeforeUnmount } from 'vue';

var global$1 = (typeof global !== "undefined" ? global :
  typeof self !== "undefined" ? self :
  typeof window !== "undefined" ? window : {});

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global$1 == 'object' && global$1 && global$1.Object === Object && global$1;

var freeGlobal$1 = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal$1 || freeSelf || Function('return this')();

var root$1 = root;

/** Built-in value references. */
var Symbol$1 = root$1.Symbol;

var Symbol$2 = Symbol$1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root$1.Date.now();
};

var now$1 = now;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * 用来处理防抖函数的 Hook，移植自 umi-hook/useDebounceFn
 * https://ahooks.js.org/zh-CN/hooks/side-effect/use-debounce-fn
 * @author jiguangrui@baidu.com
 */
function useDebounceFn(fn, options) {
    var _a;
    var wait = (_a = options === null || options === void 0 ? void 0 : options.wait) !== null && _a !== void 0 ? _a : 1000;
    var debounceRef = ref(debounce((function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn.apply(void 0, args);
    }), wait, options));
    onUnmounted(function () {
        debounceRef.value.cancel();
    });
    return {
        run: debounceRef.value,
        cancel: debounceRef.value.cancel,
        flush: debounceRef.value.flush,
    };
}

var useVisibleChange = function (_a) {
    var onShow = _a.onShow, onHide = _a.onHide;
    var handler = function () {
        if (document.visibilityState === 'visible') {
            onShow && onShow();
        }
        else {
            onHide && onHide();
        }
    };
    onMounted(function () {
        document.addEventListener('visibilitychange', handler);
    });
    onBeforeUnmount(function () {
        document.removeEventListener('visibilitychange', handler);
    });
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var dayjs_min = {exports: {}};

(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));
}(dayjs_min));

var dayjs = dayjs_min.exports;

/**
 * 过滤器
 * @author dingxin02
 * @date 2021-10-26
 */
var format = {
    /**
     * 将时间戳转化为格式化日期
     *
     * @param  {number} source  时间戳，单位为ms
     * @param  {string} formatString  日期格式，如 yyyy-MM-dd hh:mm
     * @return {string} 格式化日期
     */
    formatTime: function (time, type) {
        if (type === void 0) {
            type = 'YYYY-MM-DD HH:mm';
        }
        if (!time) {
            return '';
        }
        if (typeof time === 'string') {
            return dayjs(time).format(type);
        }
        if (typeof time === 'number') {
            time = +time;
            if (time >= 1e9 && time < 1e10) {
                var timestamp = time * 1000;
                return dayjs(new Date(timestamp)).format(type);
            }
        }
        return dayjs(time).format(type);
    },
    /**
     * 将数字转换为百分数，保留两位小数
     *
     * @param  {number} num  小数
     * @return {string} 百分数
     */
    formatRatio: function (num) {
        var formatNum = Number(num);
        if (isNaN(formatNum)) {
            console.warn('formatRate num 不合法');
            return '-';
        }
        return "".concat((formatNum * 100).toFixed(2), "%");
    },
};

/**
 * 获取下载的挂载元素
 */
function getDownloadEl() {
    var linkEl = document.querySelector('downloadLinkEl');
    if (!linkEl) {
        linkEl = document.createElement('a');
        document.body.append(linkEl);
    }
    return linkEl;
}
/**
 * 根据数据下载文件
 * @param data
 * @param filename
 */
function saveFileByData(data, filename) {
    var linkEl = getDownloadEl();
    var downloadLink = URL.createObjectURL(data);
    linkEl.setAttribute('href', downloadLink);
    if (filename) {
        linkEl.setAttribute('download', filename);
    }
    linkEl.click();
    setTimeout(function () {
        // 通过createObjectURL创建的url需要通过revokeObjectURL()来释放
        URL.revokeObjectURL(downloadLink);
        linkEl.setAttribute('href', '');
        if (filename) {
            linkEl.setAttribute('download', '');
        }
    });
}
/**
 * 通过链接下载文件，可以是cdn地址，也可以是blob对象地址
 * @param downloadLink
 * @param filename
 */
function saveFileByLink(downloadLink, filename) {
    var linkEl = getDownloadEl();
    linkEl.setAttribute('href', downloadLink);
    if (filename) {
        linkEl.setAttribute('download', filename);
    }
    linkEl.click();
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var IS_NODE$1 = (typeof window === 'undefined' && typeof global === 'object');
var NodeStorage = {
    getItem: function () { return null; },
    setItem: function () { return null; },
    removeItem: function () { return true; },
    clear: function () { return true; },
    length: 0,
};
/**
 * super cache；localStorage | sessionStorage | memory 适配器
 */
var TSuperCache = /** @class */ (function () {
    function TSuperCache() {
        this.localStorage = IS_NODE$1 ? NodeStorage : localStorage;
        this.sessionStorage = IS_NODE$1 ? NodeStorage : sessionStorage;
        this.cache = new Map();
    }
    TSuperCache.prototype.getItem = function (key, type) {
        if (type === void 0) {
            type = 'memory';
        }
        if (type === 'localStorage') {
            return JSON.parse(this.localStorage.getItem(key) || 'null');
        }
        else if (type === 'sessionStorage') {
            return JSON.parse(this.sessionStorage.getItem(key) || 'null');
        }
        return this.cache.get(key);
    };
    TSuperCache.prototype.setItem = function (key, value, type) {
        if (type === void 0) {
            type = 'memory';
        }
        if (type === 'localStorage') {
            return this.localStorage.setItem(key, JSON.stringify(value));
        }
        else if (type === 'sessionStorage') {
            return this.sessionStorage.setItem(key, JSON.stringify(value));
        }
        return this.cache.set(key, value);
    };
    TSuperCache.prototype.getSize = function (type) {
        if (type === void 0) {
            type = 'memory';
        }
        if (type === 'localStorage') {
            return this.localStorage.length;
        }
        else if (type === 'sessionStorage') {
            return this.sessionStorage.length;
        }
        return this.cache.size;
    };
    TSuperCache.prototype.clear = function (type) {
        if (type === void 0) {
            type = 'memory';
        }
        if (type === 'localStorage') {
            this.localStorage.clear();
        }
        else if (type === 'sessionStorage') {
            this.sessionStorage.clear();
        }
        else {
            this.cache.clear();
        }
    };
    TSuperCache.prototype.removeItem = function (key, type) {
        if (type === void 0) {
            type = 'memory';
        }
        if (type === 'localStorage') {
            this.localStorage.removeItem(key);
        }
        else if (type === 'sessionStorage') {
            this.sessionStorage.removeItem(key);
        }
        else {
            this.cache.delete(key);
        }
    };
    return TSuperCache;
}());

var LinkNode = /** @class */ (function () {
    function LinkNode(key, value, next, prev) {
        if (next === void 0) {
            next = null;
        }
        if (prev === void 0) {
            prev = null;
        }
        this.key = key;
        this.value = value;
        this.next = next;
        this.prev = prev;
    }
    return LinkNode;
}());
/**
 * lru cache
 * 参考：https://medium.com/dsinjs/implementing-lru-cache-in-javascript-94ba6755cda9
 */
var LRUCache = /** @class */ (function () {
    // set default limit of 10 if limit is not passed.
    function LRUCache(limit) {
        if (limit === void 0) {
            limit = 10;
        }
        this.size = 0;
        this.limit = limit;
        this.head = null;
        this.tail = null;
        // 缓存
        this.cache = new TSuperCache();
        // lru 的链表
        this.cacheLink = {};
    }
    LRUCache.prototype.set = function (key, value, type) {
        if (type === void 0) {
            type = 'memory';
        }
        var existingNode = this.existingNode(key, type);
        if (existingNode && this.cacheLink[key]) {
            this.detach(this.cacheLink[key]);
            this.size--;
        }
        else if (this.size === this.limit) {
            if (this.tail) {
                console.info('info', '[lru removed]', this.tail.key, type);
                this.cache.removeItem(this.tail.key, type);
                this.detach(this.tail);
                this.size--;
            }
        }
        // Write to head of LinkedList
        if (!this.head) {
            this.head = this.tail = new LinkNode(key, value);
        }
        else {
            var node = new LinkNode(key, value, this.head);
            this.head.prev = node;
            this.head = node;
        }
        // update cacheMap with LinkedList key and Node reference
        this.cacheLink[key] = this.head;
        this.cache.setItem(key, value, type);
        this.size++;
    };
    LRUCache.prototype.get = function (key, type) {
        if (type === void 0) {
            type = 'memory';
        }
        var existingNode = this.existingNode(key, type);
        if (existingNode) {
            var value = existingNode;
            // Make the node as new Head of LinkedList if not already
            if (this.head !== existingNode) {
                // write will automatically remove the node from it's position and make it a new head i.e most used
                this.set(key, value, type);
            }
            return value;
        }
        // eslint-disable-next-line no-console
        console.log("Item not available in cache for key ".concat(key));
    };
    LRUCache.prototype.detach = function (node) {
        if (node.prev !== null) {
            node.prev.next = node.next;
        }
        else {
            this.head = node.next;
        }
        if (node.next !== null) {
            node.next.prev = node.prev;
        }
        else {
            this.tail = node.prev;
        }
    };
    LRUCache.prototype.clear = function () {
        this.head = null;
        this.tail = null;
        this.size = 0;
        this.cache.clear();
    };
    // Invokes the callback function with every node of the chain and the index of the node.
    LRUCache.prototype.forEach = function (fn) {
        var node = this.head;
        var counter = 0;
        while (node) {
            fn(node, counter);
            node = node.next;
            counter++;
        }
    };
    // To iterate over LRU with a 'for...of' loop
    LRUCache.prototype[Symbol.iterator] = function () {
        var node;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    node = this.head;
                    _a.label = 1;
                case 1:
                    if (!node)
                        return [3 /*break*/, 3];
                    return [4 /*yield*/, node];
                case 2:
                    _a.sent();
                    node = node.next;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    };
    LRUCache.prototype.existingNode = function (key, type) {
        return this.cache.getItem(key, type);
    };
    return LRUCache;
}());

var emojiRegex = () => {
	// https://mths.be/emoji
	return /(?:[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC3\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDD-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF6](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC2\uDED0-\uDED9\uDEE0-\uDEE7]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?))/g;
};

/* eslint-disable @typescript-eslint/no-var-requires */
// import {FormItemRule} from 'element-plus/lib/components/form/src/form.type';
// http://emailregex.com/
var emailRegExp 
// eslint-disable-next-line max-len
= /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/;
var httpUrlRegExp 
// eslint-disable-next-line max-len
= /^(?:(http|https):\/\/)?((|[\w-]+\.)+[a-z0-9]+)(\.(|[\w-]+\.)+[a-z0-9]+)(\/)?(?:(\/[^/?#]+)*)?(\/)?(\?[^#]+)?(#.+)?$/;
var phoneRgeExp = /^1\d{10}$/;
// 英文字符（数字、英文字母、英文符号）校验
var engCharRegExp = /^[a-zA-Z0-9\s\`\~\!\@\#\$\%\^\&\*\(\)\_\+\-\=\[\]\{\}\\\|\;\'\'\:\"\"\,\.\/\<\>\?]*$/;
/**
 * 金额正则
 */
var moneyRegExp = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/;
// 仅英文
var onlyEngCharExp = /^[A-Za-z]+$/;
/**
 * 获取必填字符串校验规则
 * @param itemName 该表单项的名称
 * @param resetRuleOption 复写表单规则
 */
function getRequiredStringRule(itemName, resetRuleOption) {
    if (itemName === void 0) {
        itemName = '该项';
    }
    return __assign({ type: 'string', required: true, message: "\u8BF7\u8F93\u5165".concat(itemName), whitespace: true }, resetRuleOption);
}
/**
 * 获取最大字符数的校验规则
 * @param maxLength 最大字符数
 * @param resetRuleOption 复写表单规则
 */
function getMaxStringRule(maxLength, resetRuleOption) {
    return __assign({ type: 'string', max: maxLength, message: "\u6700\u591A\u8F93\u5165 ".concat(maxLength, " \u4E2A\u5B57\u7B26") }, resetRuleOption);
}
/**
 * 获取手机号格式校验规则
 * @param resetRuleOption 复写表单规则
 */
function getPhoneRule(resetRuleOption) {
    return __assign({ pattern: phoneRgeExp, message: '请输入正确的手机号格式' }, resetRuleOption);
}
/**
 * 获取邮箱校验规则
 * @param resetRuleOption 复写表单规则
 */
function getEmailRule(resetRuleOption) {
    return __assign({ type: 'email', message: '请输入正确的邮箱格式' }, resetRuleOption);
}
/**
 * 获取 http url 规则
 * @param resetRuleOption 复写表单规则
 */
function getHTTPUrlRule(resetRuleOption, option) {
    var _a = (option || {}).mode, mode = _a === void 0 ? 'default' : _a;
    var pattern = httpUrlRegExp;
    // TODO: 配置更多中 http 的校验规则
    switch (mode) {
        default:
            pattern = httpUrlRegExp;
            break;
    }
    return __assign({ pattern: pattern, message: '请输入正确的网站格式' }, resetRuleOption);
}
/**
 * 获取英文字符（数字、英文字母、英文符号）校验
 * @param resetRuleOption 复写表单规则
 */
function getEngCharRule(resetRuleOption) {
    return __assign({ pattern: engCharRegExp, message: '请输入英文' }, resetRuleOption);
}
/**
 * 获取字符串中的emoji
 */
function getEmojiRule(resetRuleOption) {
    return __assign({ validator: function (rule, value, callback) {
            if (emojiRegex().test(value)) {
                return callback(new Error('内容含有emoji表情，暂不支持，请修改'));
            }
            callback();
        } }, resetRuleOption);
}
/**
 * 获取英文字符（数字、英文字母、英文符号）校验
 * @param resetRuleOption 复写表单规则
 */
function getOnyEngCharRule(resetRuleOption) {
    return __assign({ pattern: onlyEngCharExp, message: '请输入英文, 不允许输入特殊符号和数字' }, resetRuleOption);
}
/**
 * 获取金额格式校验规则
 * @param resetRuleOption 复写表单规则
 */
function getMoneyRule(resetRuleOption) {
    return __assign({ pattern: moneyRegExp, message: '请输入正确的金额' }, resetRuleOption);
}

/**
 * 获取重定向的页面 url，规则如下：
 * 1. 如果当前页面的 url query 中有 redirect 参数，则返回 redirect 参数的值
 * 2. 如果当前页面位于 /login 路径，则返回 /
 * 3. 如果不匹配上面两种规则，仍返回当前页面的 url
 * @param {String} includeHost 返回的 url 是否包含 host
 * @returns {String}
 */
function getRedirectTarget(includeHost) {
    if (includeHost === void 0) {
        includeHost = false;
    }
    var currentUrlSearchParams = new URLSearchParams(location.search.split('?')[1]);
    var redirectTarget = currentUrlSearchParams.get('redirect') || location.pathname === '/login' ? '/' : location.pathname;
    return (includeHost ? location.host : '') + redirectTarget;
}

var config = {
    online: {
        uc_url: 'https://cas.baidu.com/staticv2/dep/common-login/api.js',
        uc_url_unlink: '//cas.baidu.com/staticv2/dep/common-login/api.js',
        uc_logout_url: 'https://cas.baidu.com/?action=logout',
        uc_logout_url_unlink: '//cas.baidu.com/?action=logout',
        passport_url: 'https://passport.baidu.com/passApi/js/uni_login_wrapper.js',
        passport_url_unlink: '//passport.baidu.com/passApi/js/uni_login_wrapper.js',
        passport_logout_url: 'https://passport.baidu.com/?logout',
        passport_logout_url_unlink: '//passport.baidu.com/?logout',
    },
    test: {
        uc_url: 'https://cas-off.baidu.com/staticv2/dep/common-login/qa-api.js',
        uc_url_unlink: '//cas-off.baidu.com/staticv2/dep/common-login/qa-api.js',
        uc_logout_url: 'https://cas-off.baidu.com/?action=logout',
        uc_logout_url_unlink: '//cas-off.baidu.com/?action=logout',
        passport_url: 'https://passport.qatest.baidu.com/passApi/js/uni_login_wrapper.js',
        passport_url_unlink: '//passport.qatest.baidu.com/passApi/js/uni_login_wrapper.js',
        passport_logout_url: 'https://passport.qatest.baidu.com/?logout',
        passport_logout_url_unlink: '//passport.qatest.baidu.com/?logout',
    },
};
/**
 * 初始化统一登录框
 * @param {Boolean} isProd 是否是生产环境
 * @param options ucCommonLogin 的配置项
 * @param passOptions passport 的配置项
 * @doc https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/WWW6pX-lL3/9ltq9MUWZu/30Hmnzo8YDHIJt
 */
var initUcCommonLogin = function (isProd, options, passOptions) {
    return __awaiter(void 0, void 0, void 0, function () {
        var env, V3_JUMP, _a, _b, appid, _c, product, _d, fromuPath, rest;
        return __generator(this, function (_e) {
            if (window.ucCommonLogin && (options === null || options === void 0 ? void 0 : options.isLayer)) {
                return [2 /*return*/];
            }
            env = isProd ? 'online' : 'test';
            V3_JUMP = "".concat(window.location.protocol, "//").concat(window.location.host, "/v3Jump.html");
            _a = options || {}, _b = _a.appid, appid = _b === void 0 ? 701 : _b, _c = _a.product, product = _c === void 0 ? 'overseadia' : _c, _d = _a.fromuPath, fromuPath = _d === void 0 ? '/nodeapi/uc/login' : _d, rest = __rest(_a, ["appid", "product", "fromuPath", "onFail", "onSuccess", "onRender"]);
            return [2 /*return*/, new Promise(function (res, rej) {
                    return __awaiter(void 0, void 0, void 0, function () {
                        var defaultOpts, error_1;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    defaultOpts = {
                                        appid: appid,
                                        product: product,
                                        multiLogin: 0,
                                        defaultLogin: 'uc',
                                        isAutoLogin: 0,
                                        // 是否浮层
                                        isLayer: 0,
                                        registerUcLink: "https://u.baidu.com/ucweb/?module=Reguser&controller=reg&appid=701&nexturl=".concat(window.location.origin, "/register'"),
                                        staticPage: V3_JUMP,
                                        // 如果监听了 success 回调、v3jump 不自动跳转、需要手动处理
                                        success: function (opt, e) {
                                            if (options === null || options === void 0 ? void 0 : options.onSuccess) {
                                                options.onSuccess(opt, e);
                                            }
                                            // 如果登录方式是 uc，需要配置登录成功后的跳转地址
                                            if (opt.type === 'uc' && typeof e === 'string') {
                                                // 登录成功后要跳转的地址，此 URL 后端服务需接入 casClient
                                                var fromu = "".concat(window.location.origin).concat(fromuPath, "?redirect=").concat(getRedirectTarget());
                                                var redirectUrlSearchParams = new URLSearchParams(e.split('?')[1]);
                                                redirectUrlSearchParams.set('u', fromu);
                                                window.location.href = e.split('?')[0] + '?' + redirectUrlSearchParams.toString();
                                            }
                                        },
                                        rendered: function (args) {
                                            if (options === null || options === void 0 ? void 0 : options.onRender) {
                                                options.onRender(args);
                                            }
                                            res(args);
                                        },
                                        fail: function (opts, errorMsg) {
                                            if (options === null || options === void 0 ? void 0 : options.onFail) {
                                                options.onFail(opts, errorMsg);
                                            }
                                            rej(errorMsg);
                                        },
                                        // 是否使用 UC 默认样式
                                        defaultCss: true,
                                        ucTitle: '百度商业账号',
                                        passportTitle: '百度账号',
                                        // window.passport.use 时传入的 options
                                        passUseOptions: {
                                            // UC 默认会传入 tangram: true
                                            // 新传入参数会覆盖 UC 默认传入参数
                                            // 使用 Passport v4 版本
                                            loginVersion: 'v4',
                                            // 是否使用 Passport 默认样式
                                            defaultCss: false,
                                        },
                                        // new magic.passport.login 时传入的 options
                                        passLoginOptions: __assign({
                                            // UC 默认会根据其他原有参数传入，
                                            // product, staticPage, loginMerge, hasPlaceholder,
                                            // u, charset, isQuickUser, memberPass, safeFlag, registerLink, hasRegUrl
                                            // 新传入参数会覆盖 UC 默认传入参数
                                            // 短信登录
                                            // sms: 5,
                                            // 默认帐号密码登录
                                            // memberPass: false,
                                            userPwdLogin: 1, product: product, u: "".concat(window.location.origin, "/auth/passport?redirect=").concat(getRedirectTarget()), memberPass: false, forgetLink: 'https://passport.baidu.com/?getpass_index', registerLink: 'https://passport.baidu.com/v2/?reg&tpl=&u=', hasRegUrl: true, staticPage: V3_JUMP
                                        }, passOptions),
                                        // Passport 登录框下 tip
                                        // passTip: 'pt',
                                        // UC 登录框下 tip
                                        // ucTip: 'ut',
                                    };
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, loadScriptAsync(config[env].uc_url)];
                                case 2:
                                    _b.sent();
                                    (_a = window.ucCommonLogin) === null || _a === void 0 ? void 0 : _a.init(__assign(__assign({}, defaultOpts), rest));
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _b.sent();
                                    // eslint-disable-next-line no-console
                                    console.log('ucCommonLogin error', error_1);
                                    rej(error_1);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    });
                })];
        });
    });
};
/**
 * 展示 ucCommonLogin 登录框（需要自行判断 initUcCommonLogin 方法已经调用成功)
 */
var showUcCommonLoginDialog = function () {
    var _a;
    (_a = window.ucCommonLogin) === null || _a === void 0 ? void 0 : _a.show();
};
/**
 * 展示 ucCommonLogin 登录框，调用时会重新初始化 ucCommonLogin 保证调用安全
 */
var showUcCommonLoginDialogSafely = function (isProd, options, passOptions) {
    return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, initUcCommonLogin(isProd, options, passOptions)];
                case 1:
                    _b.sent();
                    (_a = window.ucCommonLogin) === null || _a === void 0 ? void 0 : _a.show();
                    return [2 /*return*/];
            }
        });
    });
};
/**
 * 隐藏 ucCommonLogin 登录框 (需要自行判断 initUcCommonLogin 方法已经调用成功)
 */
var hideUcCommonLoginDialog = function () {
    var _a;
    (_a = window.ucCommonLogin) === null || _a === void 0 ? void 0 : _a.hide();
};
/**
 * 隐藏 ucCommonLogin 登录框，调用时会重新初始化 ucCommonLogin 保证调用安全
 */
var hideUcCommonLoginDialogSafely = function (isProd, options, passOptions) {
    return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, initUcCommonLogin(isProd, options, passOptions)];
                case 1:
                    _b.sent();
                    (_a = window.ucCommonLogin) === null || _a === void 0 ? void 0 : _a.hide();
                    return [2 /*return*/];
            }
        });
    });
};
/**
 * [Uc 账号退出]
 * @param isProd 是否是生产环境
 * @param fromu fromu 操作成功回调地址
 */
var logoutUc = function (isProd, fromu) {
    if (fromu === void 0) {
        fromu = window.location.href;
    }
    var env = isProd ? 'online' : 'test';
    window.location.href = "".concat(config[env].uc_logout_url_unlink, "&u=").concat(fromu);
};
/**
 * [UC 账号退出]并清除 SAAS 信息
 * @param isProd 是否是生产环境
 * @param fromu fromu 操作成功回调地址
 */
var logoutUcAndSaas = function (isProd, fromu) {
    if (fromu === void 0) {
        fromu = window.location.href;
    }
    var env = isProd ? 'online' : 'test';
    window.location.href = "".concat(window.location.origin, "/nodeapi/uc/logout?redirect=").concat(encodeURIComponent("".concat(config[env].uc_logout_url, "&u=").concat(fromu)));
};
/**
 * [Passport 账号退出]
 * @param isProd 是否是生产环境
 * @param fromu fromu 操作成功回调地址
 */
var logoutPassport = function (isProd, fromu) {
    if (fromu === void 0) {
        fromu = window.location.href;
    }
    var env = isProd ? 'online' : 'test';
    window.location.href = "".concat(config[env].passport_logout_url_unlink, "&u=").concat(fromu);
};
/**
 * [SAAS 退出登录] UC 账号
 */
var logoutSaasAndUc = function (isProd, fromu) {
    if (fromu === void 0) {
        fromu = window.location.href;
    }
    var env = isProd ? 'online' : 'test';
    window.location.href = "".concat(window.location.origin, "/nodeapi/saas/logout?redirect=").concat(encodeURIComponent("".concat(config[env].uc_logout_url, "&u=").concat(fromu)));
    return;
};
/**
 * [SAAS 退出登录] Passport 账号
 */
var logoutSaasAndPassport = function (isProd, fromu) {
    if (fromu === void 0) {
        fromu = window.location.href;
    }
    var env = isProd ? 'online' : 'test';
    window.location.href = "".concat(window.location.origin, "/nodeapi/saas/logout?redirect=").concat(encodeURIComponent("".concat(config[env].passport_logout_url, "&u=").concat(fromu)));
    return;
};

// 获取字符串长度、汉字 2、字母 1
var getAbsStrLen = function (str) { return str.replace(/[^\x00-\xff]/g, '01').length; };
var IS_NODE = typeof window === 'undefined' && typeof global === 'object';
var IS_BROWNER = typeof window !== 'undefined';
var loadJavascript = function (url) {
    return new Promise(function (res, rej) {
        var script = document.createElement('script');
        script.src = url;
        script.onload = function () {
            res(url);
        };
        script.onerror = function (err) {
            rej(err);
        };
        document.body.append(script);
    });
};
var parseJSONSafely = function (json) {
    try {
        var data = JSON.parse(json);
        return data;
    }
    catch (error) {
        return {};
    }
};
var getTrimmedString = function (s) {
    return s.trim();
};
var loadScriptAsync = function (url, callback, opt) {
    return new Promise(function (res, rej) {
        var script = document.createElement('script');
        var opts = opt || {};
        script.type = 'text/javascript';
        if (opts.charset) {
            script.charset = opts.charset;
        }
        if (opts.id) {
            script.id = opts.id;
        }
        script.onload = function () {
            callback && callback();
            res(script);
        };
        script.onerror = function (err) {
            rej(err);
        };
        script.src = url;
        document.body.appendChild(script);
    });
};

var AwsLangConfig = {
    'zh-TW': {
        langId: 27,
        name: '中文（台湾）',
        AWSCode: 'zh-TW',
    },
    'zh-HK': {
        langId: 27,
        name: '中文（香港）',
        AWSCode: 'zh-TW',
    },
    'zh-CN': {
        langId: 1,
        name: '中文（中国）',
        AWSCode: 'zh',
    },
    'zh': {
        langId: 1,
        name: '汉语',
        AWSCode: 'zh',
    },
    'en-US': {
        langId: 2,
        name: '英语（美国）',
        AWSCode: 'en',
    },
    'en-GB': {
        langId: 2,
        name: '英语（英国）',
        AWSCode: 'en',
    },
    'en': {
        langId: 2,
        name: '英语',
        AWSCode: 'en',
    },
    'ja': {
        langId: 3,
        name: '日语',
        AWSCode: 'ja',
    },
    'jp': {
        langId: 3,
        name: '日语',
        AWSCode: 'ja',
    },
    'ko': {
        langId: 4,
        name: '韩语',
        AWSCode: 'ko',
    },
    'kor': {
        langId: 4,
        name: '韩语',
        AWSCode: 'ko',
    },
    'de': {
        langId: 5,
        name: '德语',
        AWSCode: 'de',
    },
    'nl': {
        langId: 6,
        name: '荷兰语',
        AWSCode: 'nl',
    },
    'hi': {
        langId: 7,
        name: '印地语',
        AWSCode: 'hi',
    },
    'vie': {
        langId: 8,
        name: '越南语',
        AWSCode: 'vi',
    },
    'vi': {
        langId: 8,
        name: '越南语',
        AWSCode: 'vi',
    },
    'ru': {
        langId: 9,
        name: '俄语',
        AWSCode: 'ru',
    },
    'th': {
        langId: 10,
        name: '泰语',
        AWSCode: 'th',
    },
    'spa': {
        langId: 11,
        AWSCode: 'es',
        name: '西班牙语',
    },
    'es-419': {
        langId: 11,
        AWSCode: 'es',
        name: '西班牙语',
    },
    'es-ES': {
        langId: 11,
        AWSCode: 'es',
        name: '西班牙语',
    },
    'es': {
        langId: 11,
        AWSCode: 'es',
        name: '西班牙语',
    },
    'fr-FR': {
        name: '法语（法国）',
        langId: 12,
        AWSCode: 'fr',
    },
    'fr-CA': {
        name: '法语（加拿大）',
        langId: 12,
        AWSCode: 'fr',
    },
    'fr': {
        name: '法语（法国）',
        langId: 12,
        AWSCode: 'fr',
    },
    'fra': {
        name: '法语（法国）',
        langId: 12,
        AWSCode: 'fr',
    },
    'tl': {
        langId: 13,
        name: '菲律宾语',
        AWSCode: 'tl',
    },
    'fil': {
        langId: 13,
        name: '菲律宾语',
        AWSCode: 'tl',
    },
    'id': {
        name: '印尼语',
        langId: 14,
        AWSCode: 'id',
    },
    'pt': {
        name: '葡萄牙语',
        langId: 15,
        AWSCode: 'pt',
    },
    'it': {
        langId: 16,
        name: '意大利语',
        AWSCode: 'it',
    },
    'ar': {
        langId: 17,
        name: '阿拉伯语',
        AWSCode: 'ar',
    },
    'ara': {
        langId: 17,
        name: '阿拉伯语',
        AWSCode: 'ar',
    },
    'pl': {
        langId: 18,
        name: '波兰语',
        AWSCode: 'pl',
    },
    'tr': {
        langId: 19,
        name: '土耳其语',
        AWSCode: 'tr',
    },
    'urd': {
        langId: 20,
        name: '乌尔都语',
        AWSCode: 'ur',
    },
    'ur': {
        langId: 20,
        name: '乌尔都语',
        AWSCode: 'ur',
    },
    'bn': {
        langId: 21,
        name: '孟加拉语',
        AWSCode: 'bn',
    },
    'ben': {
        langId: 21,
        name: '孟加拉语',
        AWSCode: 'bn',
    },
    'cs': {
        langId: 22,
        name: '捷克语',
        AWSCode: 'cs',
    },
    // AWS不支持缅甸语，缅甸语先翻译成英语
    'my': {
        langId: 23,
        name: '缅甸语',
        AWSCode: 'en',
    },
    // AWS不支持缅甸语，缅甸语先翻译成英语
    'bur': {
        langId: 23,
        name: '缅甸语',
        AWSCode: 'en',
    },
    'he': {
        langId: 24,
        name: '希伯来语',
        AWSCode: 'he',
    },
    'heb': {
        langId: 24,
        name: '希伯来语',
        AWSCode: 'he',
    },
    // AWS不支持库尔德语，库尔德语先翻译成英语
    'ku': {
        langId: 25,
        name: '库尔德语',
        AWSCode: 'en',
    },
    'kur': {
        langId: 25,
        name: '库尔德语',
        AWSCode: 'en',
    },
    'ms': {
        langId: 26,
        name: '马来语',
        AWSCode: 'ms',
    },
    'may': {
        langId: 26,
        name: '马来语',
        AWSCode: 'ms',
    },
};

export { AwsLangConfig, IS_BROWNER, IS_NODE, LRUCache, TSuperCache, config, emailRegExp, emojiRegex as emojiRegExp, engCharRegExp, format, getAbsStrLen, getEmailRule, getEmojiRule, getEngCharRule, getHTTPUrlRule, getMaxStringRule, getMoneyRule, getOnyEngCharRule, getPhoneRule, getRequiredStringRule, getTrimmedString, hideUcCommonLoginDialog, hideUcCommonLoginDialogSafely, httpUrlRegExp, initUcCommonLogin, loadJavascript, loadScriptAsync, logoutPassport, logoutSaasAndPassport, logoutSaasAndUc, logoutUc, logoutUcAndSaas, moneyRegExp, onlyEngCharExp, parseJSONSafely, phoneRgeExp, saveFileByData, saveFileByLink, showUcCommonLoginDialog, showUcCommonLoginDialogSafely, useDebounceFn, useVisibleChange };
